export const networkStatusLinkConfig = {
  commandStopperDict: {
    //Behavior params & initialization params
    updateBehaviorParam: ['behaviorParameterChanged'],
    updateInitializationParam: ['initializationParameterChanged'],
    // Generic filter templates
    saveGenericFilterTemplateGeneralData: ['genericFilterTemplateGeneralDataSaved'],
    saveGenericFilterTemplateDetails: ['genericFilterTemplateDetailsSaved'],
    // Commission calculation methods
    saveCommissionCalculationMethod: ['commissionCalculationMethodSaved'],
    deleteCommissionCalculationMethod: ['commissionCalculationMethodDeleted'],
    //Notifications
    markNotificationAsRead: ['notificationMarkedAsRead'],
    dismissNotification: ['notificationDismissed'],
    dismissAllNotifications: ['notificationsAllDismissed'],
    // Questionnaires
    newVersionQuestionnaire: ['newVersionQuestionnaireUpdated'],
    duplicateQuestionnaire: ['duplicateQuestionnaireUpdated'],
    questionnaireDelete: ['questionnaireDeleted'],
    questionnaire: ['questionnaireUpdated'],
    questionDelete: ['questionDeleted'],
    questionActionDelete: ['questionActionDeleted'],
    // Exchange rates
    deleteExchangeRate: ['exchangeRateDeleted'],
    addOrUpdateExchangeRate: ['exchangeRateUpdated'],
    // Tax rates
    saveTaxRate: ['TaxRateSaved'],
    deleteTaxRate: ['TaxRateSaved'],
    //Generic filter params
    updateGenericFilterParam: ['genericFilterParamUpdated'],
    //Leasing commissions
    saveLeasingCommission: ['leasingCommissionSaved'],
    deleteLeasingCommission: ['leasingCommissionDeleted'],
    //Floating interest
    deleteLeasingInterestTypeDetail: ['leasingInterestTypeDetailDeleted'],
    addOrUpdateLeasingInterestTypeDetail: ['leasingInterestTypeDetailSaved'],
    //Leasing Interests
    updateLeasingInterest: ['leasingInterestSaved'],
    removeLeasingInterest: ['leasingInterestRemoved'],
    //Automatic State Transitions
    AutomaticStateTransition: ['AutomaticStateTransitionUpdated'],
    AutomaticStateTransitionRule: ['AutomaticStateTransitionRuleUpdated'],
    automaticStateTransitionRuleDelete: ['automaticStateTransitionRuleDeleted'],
    //Document Type Properties
    removeDocumentTypeProperty: ['documentTypePropertyRemoved'],
    addOrUpdateDocumentTypeProperty: ['documentTypePropertyUpdated'],
    addOrUpdateDocumentTypePropertyXState: ['documentTypePropertyXStateUpdated'],
    //FinancialProducts
    updateFinancialProductState: ['financialProductStateUpdated'],
    deleteFinancialProduct: ['financialProductDeleted'],
    addOrUpdateFinancialProduct: ['financialProductUpdated'],
    addOrUpdateFinancialProductFilter: ['financialProductFilterUpdated'],
    deleteFinancialProductFilter: ['financialProductFilterDeleted'],
    addOrUpdateFinancialProductCondition: ['financialProductConditionUpdated'],
    deleteFinancialProductRule: ['financialProductRuleDeleted'],
    addOrUpdateFinancialProductRule: ['financialProductRuleUpdated'],
    addOrUpdateFinancialProductRuleFilter: ['financialProductRuleFilterUpdated'],
    deleteFinancialProductRuleFilter: ['financialProductRuleFilterRemoved'],
    addOrUpdateFinancialProductRuleFilterCondition: ['financialProductRuleFilterConditionUpdated'],
    addOrUpdateFinancialProductRuleOutputData: ['financialProductRuleOutputDataUpdated'],
    deleteFinancialProductRuleOutputData: ['financialProductRuleOutputDataDeleted'],
    addOrUpdateFinancialProductRuleCommission: ['financialProductRuleCommissionUpdated'],
    deleteFinancialProductRuleCommission: ['financialProductRuleCommissionDeleted'],
    addOrUpdateFinancialProductRuleIncome: ['financialProductRuleIncomeUpdated'],
    deleteFinancialProductRuleIncome: ['financialProductRuleIncomeDeleted'],
    addOrUpdateFinancialProductRuleService: ['financialProductRuleServiceUpdated'],
    deleteFinancialProductRuleService: ['financialProductRuleServiceDeleted'],
    addOrUpdateFinancialProductInsurer: ['financialProductInsurerUpdated'],
    deleteFinancialProductInsurer: ['financialProductInsurerDeleted'],
    addOrUpdateFinancialProductProperty: ['financialProductPropertyUpdated'],
    deleteFinancialProductProperty: ['financialProductPropertyDeleted'],
    addOrUpdateFinancialProductResidualGrid: ['financialProductResidualGridUpdated'],
    deleteFinancialProductResidualGrid: ['financialProductResidualGridDeleted'],
    //Items
    deleteItem: ['itemRemoved'],
    saveItemGeneralData: ['itemGeneralDataSaved'],
    savePropertyGeneralData: ['itemPropertyGeneralDataSaved'],
    deleteItemProperty: ['itemPropertyRemoved'],
    savePropertyValue: ['propertyValueSaved'],
    deletePropertyValue: ['propertyValueRemoved'],
    //Insurance conventions
    addOrUpdateInsuranceConvention: ['insuranceConventionGeneralDataUpdated'],
    updateInsuranceConventionConditions: ['insuranceConventionConditionsUpdated'],
    addOrUpdateInsuranceConventionRisk: ['insuranceConventionRiskSaved'],
    deleteInsuranceConventionRisk: ['insuranceConventionRiskDeleted'],
    addOrUpdateInsuranceConventionInsurer: ['insuranceConventionInsurerUpdated'],
    deleteInsuranceConventionInsurer: ['insuranceConventionInsurerDeleted'],
    addOrUpdateConventionCommission: ['insuranceConventionCommissionsUpdated'],
    deleteInsuranceConventionCommission: ['insuranceConventionCommissionDeleted'],
    addOrUpdateInsuranceUsageGrid: ['insuranceUsageGridSaved'],
    deleteInsuranceUsageGrid: ['insuranceUsageGridDeleted'],
    addOrUpdateConventionItemType: ['insuranceConventionItemTypeUpdated'],
    deleteInsuranceConventionItemType: ['insuranceConventionItemTypeDeleted'],
    addOrUpdateInsuranceConventionDeductibleCost: ['insuranceConventionDeductibleCostSaved'],
    deleteInsuranceConventionDeductibleCost: ['insuranceConventionDeductibleCostDeleted'],
    addOrUpdateInsuranceConventionAdditionalData: ['insuranceConventionAdditionalDataSaved'],
    deleteInsuranceConventionAdditionalData: ['insuranceConventionAdditionalDataDeleted'],
    //Numeric precisions
    updateFieldDecimalPlacesConfig: ['fieldDecimalPlacesConfigUpdated'],
    //Partner types
    savePartnerTypes: ['partnerTypesSaved'],
    deletePartnerType: ['partnerTypeDeleted'],
    // Account statements
    addOrUpdateAccountStatement: ['accountStatementUpdated'],
    addOrUpdateAccountStatementDetail: ['accountStatementDetailUpdated'],
    deleteAccountStatementDetail: ['accountStatementDetailDeleted'],
    deleteAccountStatement: ['accountStatementDeleted'],
    addOrUpdateAccountStatementIndicator: ['accountStatementIndicatorUpdated'],
    deleteAccountStatementIndicator: ['accountStatementIndicatorDeleted'],
    //Leasing expense types
    deleteLeasingExpenseType: ['leasingExpenseTypeDeleted'],
    saveLeasingExpenseType: ['leasingExpenseTypeSaved']
  }
};
